import { useRef } from 'react'
import { useDispatch } from 'react-redux'
import useWebSocket from 'react-use-websocket'
import { messageReceived, setAdditionalRequestId } from 'Slices/websocketSlice'
import { setSnackbar } from 'Containers/shared/snackbar/SnackbarSlice'
import { useLoginStatusQuery } from 'Services/global/authentication'
import { WebSocketMethods } from 'Types/webSocketMethods'

const pingMessage = {
  method: WebSocketMethods.ping,
  data: null,
}
interface SocketResponse {
  sendMessage: (message: string) => void,
  messageWrapperForMultiRequests: (message: string, isAdditional: string) => void
}

const PING_INTERVAL = 30000

export const useSocket = (setResponse?): SocketResponse => {
  const { data: loginInfo } = useLoginStatusQuery()
  const dispatch = useDispatch()
  const baseUrl =
    process.env.REACT_APP_WS_BASE_URL + 'Authorization=' + loginInfo?.wsToken
  const intervalId = useRef(null)

  const handleOpen = () => {
    sendMessage(JSON.stringify(pingMessage))
    intervalId.current = setInterval(() => {
      sendMessage(JSON.stringify(pingMessage))
    }, PING_INTERVAL)
  }

  const handleClose = () => {
    clearInterval(intervalId.current)
  }

  const handleMessage = (message) => {
    const data = JSON.parse(message?.data)
    if (data?.method !== WebSocketMethods.ping && data?.method !== WebSocketMethods.debug) {
      setResponse && setResponse(data?.data?.data?.data)
      if(data?.data?.is_error) {
        dispatch(setSnackbar(data?.data))
      } else {
        dispatch(messageReceived(data?.data?.data?.pagination ? {...data?.data?.data, request_id: data?.meta?.request_id } : data?.data?.data))
      }
    }
  }

  const { sendMessage } = useWebSocket(
    baseUrl,
    {
      share: true,
      shouldReconnect: () => true,
      onOpen: handleOpen,
      onClose: handleClose,
      onMessage: handleMessage,
    },
    Boolean(loginInfo?.wsToken)
  )

  const messageWrapperForMultiRequests = (message, requestId) => {
    if(requestId) {
      dispatch(setAdditionalRequestId(requestId))
    }
    sendMessage(message)
  }

  return { messageWrapperForMultiRequests,
    sendMessage
   }
}
